module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-2.33cdc298.png";